import { ButtonLink, Spinner, Stack } from 'component-library';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';

import { SuspenseBoundary } from '@/components/SuspenseBoundary';
import { useOrganizationWorkstream } from '@/hooks/useOrganizationWorkstream';
import { usePathSet } from '@/hooks/usePathSet';
import { useWorkstreamId } from '@/pages/shared/home/hooks/useWorkstreamId';
import { buildPath } from '@/utils/buildPath';

export const WorkstreamButtonLink = () => {
  const workstreamId = useWorkstreamId();

  if (!workstreamId) {
    return null;
  }

  return (
    <ErrorBoundary FallbackComponent={() => null}>
      <SuspenseBoundary
        fallback={
          <Stack centerMain>
            <Spinner size={10} />
          </Stack>
        }
      >
        <WorkstreamButtonLinkBase id={workstreamId} />
      </SuspenseBoundary>
    </ErrorBoundary>
  );
};

const WorkstreamButtonLinkBase = ({ id }: { id: string }) => {
  const { t } = useTranslation();
  const workstream = useOrganizationWorkstream(id).data;
  const paths = usePathSet();

  const to = buildPath(paths.home, { queryParams: { workstreamId: id } });

  return (
    <ButtonLink
      to={to}
      variant='text'
      className='mx-4 py-2 px-3 rounded-lg bg-primary-100 justify-start hover:bg-primary-100 hover:bg-primary-light text-left'
    >
      <Stack direction='row' spacing={2} className='text-white-100' centerMain>
        <i className='ri-folder-3-fill text-xl' />
        <Stack spacing={0.5}>
          <span className='typography-overline text-2xs opacity-90'>{t('global.workstream.labels.workstream')}</span>
          <span className='typography-body1Semibold'>{workstream.title}</span>
        </Stack>
      </Stack>
    </ButtonLink>
  );
};
